export const NATIONALITES = [
    {
        pays: "",
        value: "Afghan",
        nationalites: "Afghan",
    },
    {
        pays: "",
        value: "Albanais",
        nationalites: "Albanais",
    },
    {
        pays: "",
        value: "Algérien",
        nationalites: "Algérien",
    },
    {
        pays: "",
        value: "Allemand",
        nationalites: "Allemand",
    },
    {
        pays: "",
        value: "Américain",
        nationalites: "Américain",
    },
    {
        pays: "",
        value: "Andorran",
        nationalites: "Andorran",
    },
    {
        pays: "",
        value: "Angolais",
        nationalites: "Angolais",
    },
    {
        pays: "",
        value: "Antiguans",
        nationalites: "Antiguans",
    },
    {
        pays: "",
        value: "Argentin",
        nationalites: "Argentin",
    },
    {
        pays: "",
        value: "arménien",
        nationalites: "arménien",
    },
    {
        pays: "",
        value: "Australien",
        nationalites: "Australien",
    },
    {
        pays: "",
        value: "Autrichien",
        nationalites: "Autrichien",
    },
    {
        pays: "",
        value: "Azerbaïdjanais",
        nationalites: "Azerbaïdjanais",
    },
    {
        pays: "",
        value: "Bahaméen",
        nationalites: "Bahaméen",
    },
    {
        pays: "",
        value: "Bahreïn",
        nationalites: "Bahreïn",
    },
    {
        pays: "",
        value: "Bangladesh",
        nationalites: "Bangladesh",
    },
    {
        pays: "",
        value: "Barbadienne",
        nationalites: "Barbadienne",
    },
    {
        pays: "",
        value: "Barbudans",
        nationalites: "Barbudans",
    },
    {
        pays: "",
        value: "Batswana",
        nationalites: "Batswana",
    },
    {
        pays: "",
        value: "biélorusse",
        nationalites: "biélorusse",
    },
    {
        pays: "",
        value: "Belge",
        nationalites: "Belge",
    },
    {
        pays: "",
        value: "Belize",
        nationalites: "Belize",
    },
    {
        pays: "",
        value: "Béninois",
        nationalites: "Béninois",
    },
    {
        pays: "",
        value: "Bhoutanais",
        nationalites: "Bhoutanais",
    },
    {
        pays: "",
        value: "Bolivien",
        nationalites: "Bolivien",
    },
    {
        pays: "",
        value: "Bosniaque",
        nationalites: "Bosniaque",
    },
    {
        pays: "",
        value: "Brésilien",
        nationalites: "Brésilien",
    },
    {
        pays: "",
        value: "Britannique",
        nationalites: "Britannique",
    },
    {
        pays: "",
        value: "Bruneian",
        nationalites: "Bruneian",
    },
    {
        pays: "",
        value: "bulgare",
        nationalites: "bulgare",
    },
    {
        pays: "",
        value: "Burkinabé",
        nationalites: "Burkinabé",
    },
    {
        pays: "",
        value: "birman",
        nationalites: "birman",
    },
    {
        pays: "",
        value: "Burundais",
        nationalites: "Burundais",
    },
    {
        pays: "",
        value: "Cambodgien",
        nationalites: "Cambodgien",
    },
    {
        pays: "",
        value: "Cap-verdien",
        nationalites: "Cap-verdien",
    },
    {
        pays: "",
        value: "Centrafricaine",
        nationalites: "Centrafricaine",
    },
    {
        pays: "",
        value: "Tchadien",
        nationalites: "Tchadien",
    },
    {
        pays: "",
        value: "Chilien",
        nationalites: "Chilien",
    },
    {
        pays: "",
        value: "Chinois",
        nationalites: "Chinois",
    },
    {
        pays: "",
        value: "Colombien",
        nationalites: "Colombien",
    },
    {
        pays: "",
        value: "Comoran",
        nationalites: "Comoran",
    },
    {
        pays: "",
        value: "Congolais - Kinshasa",
        nationalites: "Congolais - Kinshasa",
    },
    {
        pays: "",
        value: "Congolais - Brazzaville",
        nationalites: "Congolais - Brazzaville",
    },
    {
        pays: "",
        value: "Costaricain",
        nationalites: "Costaricain",
    },
    {
        pays: "",
        value: "Croate",
        nationalites: "Croate",
    },
    {
        pays: "",
        value: "Cubain",
        nationalites: "Cubain",
    },
    {
        pays: "",
        value: "chypriote",
        nationalites: "chypriote",
    },
    {
        pays: "",
        value: "danois",
        nationalites: "danois",
    },
    {
        pays: "",
        value: "Djibouti",
        nationalites: "Djibouti",
    },
    {
        pays: "",
        value: "Dominicain",
        nationalites: "Dominicain",
    },
    {
        pays: "",
        value: "Néerlandais",
        nationalites: "Néerlandais",
    },
    {
        pays: "",
        value: "Timorais oriental",
        nationalites: "Timorais oriental",
    },
    {
        pays: "",
        value: "équatorien",
        nationalites: "équatorien",
    },
    {
        pays: "",
        value: "Egyptien",
        nationalites: "Egyptien",
    },
    {
        pays: "",
        value: "Emirien",
        nationalites: "Emirien",
    },
    {
        pays: "",
        value: "Equatorial Guinean",
        nationalites: "Equatorial Guinean",
    },
    {
        pays: "",
        value: "Érythréen",
        nationalites: "Érythréen",
    },
    {
        pays: "",
        value: "estonien",
        nationalites: "estonien",
    },
    {
        pays: "",
        value: "Ethiopian",
        nationalites: "Ethiopian",
    },
    {
        pays: "",
        value: "Fidjien",
        nationalites: "Fidjien",
    },
    {
        pays: "",
        value: "Philippin",
        nationalites: "Philippin",
    },
    {
        pays: "",
        value: "finnois",
        nationalites: "finnois",
    },
    {
        pays: "",
        value: "Français",
        nationalites: "Français",
    },
    {
        pays: "",
        value: "Gabonais",
        nationalites: "Gabonais",
    },
    {
        pays: "",
        value: "Gambien",
        nationalites: "Gambien",
    },
    {
        pays: "",
        value: "Géorgien",
        nationalites: "Géorgien",
    },
    {
        pays: "",
        value: "Ghanéen",
        nationalites: "Ghanéen",
    },
    {
        pays: "",
        value: "Grec",
        nationalites: "Grec",
    },
    {
        pays: "",
        value: "Grenadien",
        nationalites: "Grenadien",
    },
    {
        pays: "",
        value: "Guatémaltèque",
        nationalites: "Guatémaltèque",
    },
    {
        pays: "",
        value: "Guinée-Bissau",
        nationalites: "Guinée-Bissau",
    },
    {
        pays: "",
        value: "Guinéen",
        nationalites: "Guinéen",
    },
    {
        pays: "",
        value: "Guyanais",
        nationalites: "Guyanais",
    },
    {
        pays: "",
        value: "Haïtien",
        nationalites: "Haïtien",
    },
    {
        pays: "",
        value: "Herzegovinian",
        nationalites: "Herzegovinian",
    },
    {
        pays: "",
        value: "Hondurien",
        nationalites: "Hondurien",
    },
    {
        pays: "",
        value: "Hongrois",
        nationalites: "Hongrois",
    },
    {
        pays: "",
        value: "Islandais",
        nationalites: "Islandais",
    },
    {
        pays: "",
        value: "Indien",
        nationalites: "Indien",
    },
    {
        pays: "",
        value: "Indonésien",
        nationalites: "Indonésien",
    },
    {
        pays: "",
        value: "Iranien",
        nationalites: "Iranien",
    },
    {
        pays: "",
        value: "Irakien",
        nationalites: "Irakien",
    },
    {
        pays: "",
        value: "Irlandais",
        nationalites: "Irlandais",
    },
    {
        pays: "",
        value: "Israélien",
        nationalites: "Israélien",
    },
    {
        pays: "",
        value: "Italien",
        nationalites: "Italien",
    },
    {
        pays: "",
        value: "ivoirien",
        nationalites: "ivoirien",
    },
    {
        pays: "",
        value: "Jamaïcain",
        nationalites: "Jamaïcain",
    },
    {
        pays: "",
        value: "Japonais",
        nationalites: "Japonais",
    },
    {
        pays: "",
        value: "Jordanien",
        nationalites: "Jordanien",
    },
    {
        pays: "",
        value: "kazakhstanais",
        nationalites: "kazakhstanais",
    },
    {
        pays: "",
        value: "Kenyan",
        nationalites: "Kenyan",
    },
    {
        pays: "",
        value: "Kittian and Nevisian",
        nationalites: "Kittian and Nevisian",
    },
    {
        pays: "",
        value: "Koweïtien",
        nationalites: "Koweïtien",
    },
    {
        pays: "",
        value: "Kirghiz",
        nationalites: "Kirghiz",
    },
    {
        pays: "",
        value: "Laotien",
        nationalites: "Laotien",
    },
    {
        pays: "",
        value: "letton",
        nationalites: "letton",
    },
    {
        pays: "",
        value: "Libanais",
        nationalites: "Libanais",
    },
    {
        pays: "",
        value: "Libérien",
        nationalites: "Libérien",
    },
    {
        pays: "",
        value: "Libyen",
        nationalites: "Libyen",
    },
    {
        pays: "",
        value: "Liechtenstein",
        nationalites: "Liechtenstein",
    },
    {
        pays: "",
        value: "lituanien",
        nationalites: "lituanien",
    },
    {
        pays: "",
        value: "Luxembourgeois",
        nationalites: "Luxembourgeois",
    },
    {
        pays: "",
        value: "Macédonien",
        nationalites: "Macédonien",
    },
    {
        pays: "",
        value: "Malgache",
        nationalites: "Malgache",
    },
    {
        pays: "",
        value: "Malawienne",
        nationalites: "Malawienne",
    },
    {
        pays: "",
        value: "Malaysian",
        nationalites: "Malaysian",
    },
    {
        pays: "",
        value: "Maldivan",
        nationalites: "Maldivan",
    },
    {
        pays: "",
        value: "Malien",
        nationalites: "Malien",
    },
    {
        pays: "",
        value: "maltais",
        nationalites: "maltais",
    },
    {
        pays: "",
        value: "Marshallese",
        nationalites: "Marshallese",
    },
    {
        pays: "",
        value: "Mauritanien",
        nationalites: "Mauritanien",
    },
    {
        pays: "",
        value: "Mauricien",
        nationalites: "Mauricien",
    },
    {
        pays: "",
        value: "Mauricien",
        nationalites: "Mauricien",
    },
    {
        pays: "",
        value: "Mexicain",
        nationalites: "Mexicain",
    },
    {
        pays: "",
        value: "Micronésien",
        nationalites: "Micronésien",
    },
    {
        pays: "",
        value: "Moldave",
        nationalites: "Moldave",
    },
    {
        pays: "",
        value: "Monacan",
        nationalites: "Monacan",
    },
    {
        pays: "",
        value: "Mongol",
        nationalites: "Mongol",
    },
    {
        pays: "",
        value: "Marocain",
        nationalites: "Marocain",
    },
    {
        pays: "",
        value: "Mosotho",
        nationalites: "Mosotho",
    },
    {
        pays: "",
        value: "Motswana",
        nationalites: "Motswana",
    },
    {
        pays: "",
        value: "Mozambicain",
        nationalites: "Mozambicain",
    },
    {
        pays: "",
        value: "Nauruan",
        nationalites: "Nauruan",
    },
    {
        pays: "",
        value: "Népalais",
        nationalites: "Népalais",
    },
    {
        pays: "",
        value: "Néo-Zélandais",
        nationalites: "Néo-Zélandais",
    },
    {
        pays: "",
        value: "Ni-Vanuatu",
        nationalites: "Ni-Vanuatu",
    },
    {
        pays: "",
        value: "Nicaraguayen",
        nationalites: "Nicaraguayen",
    },
    {
        pays: "",
        value: "Nigérien",
        nationalites: "Nigérien",
    },
    {
        pays: "",
        value: "Nord-coréen",
        nationalites: "Nord-coréen",
    },
    {
        pays: "",
        value: "Irlandais du Nord",
        nationalites: "Irlandais du Nord",
    },
    {
        pays: "",
        value: "Norvégien",
        nationalites: "Norvégien",
    },
    {
        pays: "",
        value: "Oman",
        nationalites: "Oman",
    },
    {
        pays: "",
        value: "Pakistanais",
        nationalites: "Pakistanais",
    },
    {
        pays: "",
        value: "Palaosien",
        nationalites: "Palaosien",
    },
    {
        pays: "",
        value: "panaméen",
        nationalites: "panaméen",
    },
    {
        pays: "",
        value: "Papouasie-Nouvelle-Guinée",
        nationalites: "Papouasie-Nouvelle-Guinée",
    },
    {
        pays: "",
        value: "Paraguayen",
        nationalites: "Paraguayen",
    },
    {
        pays: "",
        value: "Péruvien",
        nationalites: "Péruvien",
    },
    {
        pays: "",
        value: "Polonais",
        nationalites: "Polonais",
    },
    {
        pays: "",
        value: "Portugais",
        nationalites: "Portugais",
    },
    {
        pays: "",
        value: "Qatar",
        nationalites: "Qatar",
    },
    {
        pays: "",
        value: "roumain",
        nationalites: "roumain",
    },
    {
        pays: "",
        value: "Russe",
        nationalites: "Russe",
    },
    {
        pays: "",
        value: "Rwandais",
        nationalites: "Rwandais",
    },
    {
        pays: "",
        value: "Sainte-Lucie",
        nationalites: "Sainte-Lucie",
    },
    {
        pays: "",
        value: "salvadorien",
        nationalites: "salvadorien",
    },
    {
        pays: "",
        value: "Samoan",
        nationalites: "Samoan",
    },
    {
        pays: "",
        value: "Saint-Marin",
        nationalites: "Saint-Marin",
    },
    {
        pays: "",
        value: "Sao Tomean",
        nationalites: "Sao Tomean",
    },
    {
        pays: "",
        value: "Arabie",
        nationalites: "Arabie",
    },
    {
        pays: "",
        value: "écossais",
        nationalites: "écossais",
    },
    {
        pays: "",
        value: "Sénégalais",
        nationalites: "Sénégalais",
    },
    {
        pays: "",
        value: "Serbe",
        nationalites: "Serbe",
    },
    {
        pays: "",
        value: "Seychellois",
        nationalites: "Seychellois",
    },
    {
        pays: "",
        value: "sierra léonais",
        nationalites: "sierra léonais",
    },
    {
        pays: "",
        value: "Singapourienne",
        nationalites: "Singapourienne",
    },
    {
        pays: "",
        value: "slovaque",
        nationalites: "slovaque",
    },
    {
        pays: "",
        value: "Slovène",
        nationalites: "Slovène",
    },
    {
        pays: "",
        value: "Solomon Islander",
        nationalites: "Solomon Islander",
    },
    {
        pays: "",
        value: "Somali",
        nationalites: "Somali",
    },
    {
        pays: "",
        value: "Sud-africain",
        nationalites: "Sud-africain",
    },
    {
        pays: "",
        value: "Sud-coréen",
        nationalites: "Sud-coréen",
    },
    {
        pays: "",
        value: "Espagnol",
        nationalites: "Espagnol",
    },
    {
        pays: "",
        value: "Sri lankais",
        nationalites: "Sri lankais",
    },
    {
        pays: "",
        value: "Soudanais",
        nationalites: "Soudanais",
    },
    {
        pays: "",
        value: "Surinamer",
        nationalites: "Surinamer",
    },
    {
        pays: "",
        value: "Swazi",
        nationalites: "Swazi",
    },
    {
        pays: "",
        value: "suédois",
        nationalites: "suédois",
    },
    {
        pays: "",
        value: "Suisse",
        nationalites: "Suisse",
    },
    {
        pays: "",
        value: "Syrien",
        nationalites: "Syrien",
    },
    {
        pays: "",
        value: "Taïwanais",
        nationalites: "Taïwanais",
    },
    {
        pays: "",
        value: "Tadjik",
        nationalites: "Tadjik",
    },
    {
        pays: "",
        value: "Tanzanien",
        nationalites: "Tanzanien",
    },
    {
        pays: "",
        value: "Tchèque",
        nationalites: "Tchèque",
    },
    {
        pays: "",
        value: "Thaï",
        nationalites: "Thaï",
    },
    {
        pays: "",
        value: "Togolais",
        nationalites: "Togolais",
    },
    {
        pays: "",
        value: "Tongan",
        nationalites: "Tongan",
    },
    {
        pays: "",
        value: "Trinidadian or Tobagonian",
        nationalites: "Trinidadian or Tobagonian",
    },
    {
        pays: "",
        value: "Tunisien",
        nationalites: "Tunisien",
    },
    {
        pays: "",
        value: "Turc",
        nationalites: "Turc",
    },
    {
        pays: "",
        value: "Tuvaluan",
        nationalites: "Tuvaluan",
    },
    {
        pays: "",
        value: "Ougandais",
        nationalites: "Ougandais",
    },
    {
        pays: "",
        value: "Ukrainien",
        nationalites: "Ukrainien",
    },
    {
        pays: "",
        value: "Uruguayen",
        nationalites: "Uruguayen",
    },
    {
        pays: "",
        value: "Ouzbékistan",
        nationalites: "Ouzbékistan",
    },
    {
        pays: "",
        value: "Vénézuélien",
        nationalites: "Vénézuélien",
    },
    {
        pays: "",
        value: "Vietnamien",
        nationalites: "Vietnamien",
    },
    {
        pays: "",
        value: "Gallois",
        nationalites: "Gallois",
    },
    {
        pays: "",
        value: "Yéménite",
        nationalites: "Yéménite",
    },
    {
        pays: "",
        value: "Zambien",
        nationalites: "Zambien",
    },
    {
        pays: "",
        value: "Zimbabwéen",
        nationalites: "Zimbabwéen",
    },
]



// WEBPACK FOOTER //
// ./src/data/nationalites.js